/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "sensors";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface GpsGeoidPb {
}

export enum GpsGeoidPb_Enum {
  UNKNOWN = 0,
  EGM96 = 1,
  WGS84 = 2,
  EGM08 = 3,
  UNRECOGNIZED = -1,
}

export function gpsGeoidPb_EnumFromJSON(object: any): GpsGeoidPb_Enum {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return GpsGeoidPb_Enum.UNKNOWN;
    case 1:
    case "EGM96":
      return GpsGeoidPb_Enum.EGM96;
    case 2:
    case "WGS84":
      return GpsGeoidPb_Enum.WGS84;
    case 3:
    case "EGM08":
      return GpsGeoidPb_Enum.EGM08;
    case -1:
    case "UNRECOGNIZED":
    default:
      return GpsGeoidPb_Enum.UNRECOGNIZED;
  }
}

export function gpsGeoidPb_EnumToJSON(object: GpsGeoidPb_Enum): string {
  switch (object) {
    case GpsGeoidPb_Enum.UNKNOWN:
      return "UNKNOWN";
    case GpsGeoidPb_Enum.EGM96:
      return "EGM96";
    case GpsGeoidPb_Enum.WGS84:
      return "WGS84";
    case GpsGeoidPb_Enum.EGM08:
      return "EGM08";
    case GpsGeoidPb_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseGpsGeoidPb(): GpsGeoidPb {
  return {};
}

export const GpsGeoidPb = {
  encode(_: GpsGeoidPb, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GpsGeoidPb {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGpsGeoidPb();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): GpsGeoidPb {
    return {};
  },

  toJSON(_: GpsGeoidPb): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<GpsGeoidPb>, I>>(base?: I): GpsGeoidPb {
    return GpsGeoidPb.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GpsGeoidPb>, I>>(_: I): GpsGeoidPb {
    const message = createBaseGpsGeoidPb();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
